module.exports = __webpack_public_path__ + "img/c3f61d5.jpeg";